import { Invoice, InvoiceQueryParams, PaginatedResponse } from '@ravago/shared/page-data/models/elements';

export class InvoiceClientUtils {
  static async getClosedInvoices(query?: InvoiceQueryParams): Promise<PaginatedResponse<Invoice[]> | undefined> {
    const searchParams = new URLSearchParams();
    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          searchParams.append(key, value.toString());
        }
      });
    }

    try {
      const response = await fetch(`/api/invoices/closed?${searchParams.toString()}`);

      if (!response.ok) {
        return undefined;
      }

      return await response.json();
    } catch (error) {
      return undefined;
    }
  }
}
